import { makeStyles } from "@material-ui/core";
import { Box, Button, IconButton, Theme } from "@mui/material";
import { Card, Typography } from "@mui/material";
import UsageGraph from "../widgets/UsageGraph";
import { graph3, monthTicks } from "src/mock/graph";
import { Close as CloseIcon } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useSelector } from "src/store";
import usageBarIcon from "src/assets/usageBarIcon.svg";
import { useMediaQuery } from "@mui/material";
import { CancelButton } from "../form/InputFields";

const info_init = {
  usages: [],
  annual: 0,
  avg: 0,
};
export default ({ handleClose, changeView }) => {
  const state = useSelector((state) => state.bkv);
  const [landscape, setLandscape] = useState(false);

  const classes = useStyles({ landscape });

  let data = info_init;
  const usageArray = Object.keys(state.usage)
    .map((month) => Number(month))
    .sort((a, b) => a - b)
    .map(
      (month) =>
        state.usage[String(month).padStart(2, "0")] ||
        state.usage[String(month)]
    );
  data.usages = usageArray.map((usg, index) => {
    return {
      name: monthTicks[index],
      usage: usg,
    };
  });

  useEffect(() => {
    function orientationChange() {
      const angle = window.screen.orientation.angle;
      const _landscape = angle === 90 || angle === 180;
      setLandscape(_landscape);
    }
    orientationChange();
    window.addEventListener("orientationchange", orientationChange);
    return () => {
      window.removeEventListener("orientationchange", orientationChange);
    };
  }, []);

  const Close = () => {
    changeView("options");
    handleClose("usageModal");
  };

  return (
    <Card className={classes.root}>
      <IconButton className={classes.crossIcon} onClick={Close}>
        <CloseIcon fontSize="large" />
      </IconButton>
      <Typography className={classes.title}>
        Your usage insight by month
      </Typography>
      <Box className={classes.stats}>
        <Box className="row">
          <Typography className="title">Annual Usage</Typography>
          <Typography className="val">
            {state.usageInfo.annual.toFixed(0)} kWh
          </Typography>
        </Box>
        <Box className="row">
          <Typography className="title">Avg. Monthly Usage</Typography>
          <Typography className="val">
            {state.usageInfo.month_avg.toFixed(1)} kWh
          </Typography>
        </Box>
      </Box>

      <Box className={classes.graphContainer}>
        <Box className="container">
          <img src={usageBarIcon} alt="gimmicky-icon" />
          <Typography>Your kWh usage</Typography>
        </Box>
        {/* TODO: format graph2 usage for graph3  */}
        {data.usages.length ? (
          <UsageGraph data={data.usages} dataKey={"name"} />
        ) : (
          <Typography>No usage</Typography>
        )}
      </Box>
      {/* <CancelButton sx={{ marginTop: 6, alignSelf: "center" }} >Back</CancelButton> */}
    </Card>
  );
};

const useStyles = makeStyles<Theme, { landscape: boolean }>((theme: Theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    boxSizing: "border-box",
    padding: "30px 50px 50px 50px",
    overflowY: "auto",
    [theme.breakpoints.down("lg")]: {
      width: "92vw",
      padding: "30px 30px 50px 30px",
    },
    [theme.breakpoints.down("md")]: {
      padding: "30px 30px 50px 16px",
      width: (props) => (props.landscape ? "100%" : "92vw"),
      height: (props) => (props.landscape ? "100vh" : "auto"),
    },
    [theme.breakpoints.down("sm")]: {
      width: "100% !important",
      height: "100vh !important",
    },
  },
  crossIcon: {
    transform: "scale(0.8)",
    position: "absolute",
    top: 15,
    right: 20,
    [theme.breakpoints.down("md")]: {
      top: 0,
      right: 10,
    },
  },
  title: {
    fontSize: 32,
    color: "#09507F",
    fontWeight: 500,
    textAlign: "center",
    fontFamily: "Larken DEMO medium",
    [theme.breakpoints.down("md")]: {
      fontSize: 26,
    },
  },
  stats: {
    marginTop: 20,
    display: "flex",
    justifyContent: "center",
    gap: 20,
    "& .row": {
      width: "100%",
      textAlign: "center",
      "& .title": {
        fontSize: 24,
      },
      "& .val": {
        fontSize: 24,
        fontWeight: "bold",
      },
      [theme.breakpoints.down("md")]: {
        "& .title": {
          fontSize: 18,
        },
        "& .val": {
          fontSize: 18,
        },
      },
    },
  },
  graphContainer: {
    marginTop: 30,
    borderRadius: 40,
    border: "1px solid #99D7CF",
    padding: "20px 10px 20px 10px",
    width: "100%",
    "& .container": {
      display: "flex",
      gap: 8,
      alignItems: "center",
      padding: "10px 0px 30px 30px",
      "& p": {
        fontSize: 16,
        fontWeight: 450,
      },
    },
    [theme.breakpoints.down("md")]: {
      borderRadius: 24,
    },
    [theme.breakpoints.down("sm")]: {
      gap: 30,
      "& img": {
        width: 30,
        height: 5,
        objectFit: "cover",
      },
      "& p": {
        fontSize: 10,
      },
    },
  },
  button: {
    marginTop: 50,
    backgroundColor: "#009A88",
    fontWeight: "bold",
    color: "#fff",
    borderRadius: 360,
    width: 316,
    height: 64,
    fontSize: 18,
    alignSelf: "center",
    padding: "12px, 24px, 12px, 24px",
  },
}));
